import React, { useState, useCallback, useEffect } from "react";
import { Header } from "../components/Header";
import { DefaultContainer } from "../components/DefaultContainer";
import { ModuleInput } from "../components/ModuleInput";
import { ChatContainer } from "../components/ChatContainer";
import { toast } from "react-toastify";
import { fetchModules, fetchPreview, getAllModules } from "../api/genapi";
import { useGenAIWebSocket } from "../api/useGenAiWebSocket";
import CircularProgressBar from "Uitls/CircularProgressBar";
import { getFilteredSelectedSlide } from "../components/utils/handlePages";

export const GenAi = () => {
  const [messages, setMessages] = useState([]);
  const [showChat, setShowChat] = useState(false);
  const [selectedeDetail, setSelectedEdetail] = useState(null);
  const [selectedSlide, setSelectedSlide] = useState(null);
  const [edtName, setedtName] = useState(null);
  const [productCountry, setProductCountry] = useState(null);
  const [textShow, setTextShow] = useState(false);
  const [edetailtextShow, SetedetailTextShow] = useState(false);
  const [slidetextShow, SetSlideTextShow] = useState(false);
  //slides
  const [slidesData, setSlidesData] = useState(null);
  const [modulesData, setModulesData] = useState([]);
  const [modulesCache, setModulesCache] = useState({}); // Cache for slide modules
  const [userText, setUserText] = useState("");
  const [slideBubbleState, setSlideBubbleState] = useState({
    isShow: false,
    selectedCount: 0,
  });
  const [userCollectedMeta, setUserCollectedMeta] = useState([]);
  const [dropDownlist, setDropDownlist] = useState({
    topiclist: [],
    confirmationPop: false,
  });
  const [comboSlides, setComboSlides] = useState([]);
  const [showNewBubble, setShowNewBubble] = useState(false);
  const [goforward, setGoForward] = useState(false);
  const [recModules, setRecModules] = useState(false);
  const [lineCount, setLineCount] = useState(1);
  const {
    isConnected,
    sendMessage,
    fetchProductCountry,
    onResponse,
    reconnect,
    disconnect,
    wsloading,
  } = useGenAIWebSocket();
  // multimodal creaytion
  const [showModuleCreation, setShowModuleCreation] = useState(false);
  const [multiModuleCreation, setMultiModuleCreation] = useState(false);
  const [showSlideMsg, setShowSlideMsg] = useState(false);
  const [generateMultiMod, setGenerateMultiMod] = useState(false);
  const [goforGenerate, setGoforGenerate] = useState(false);
  const [cancelGenerate, setCancelGenerate] = useState(false);
  const [inputHidden, setInputHidden] = useState(false);
  const [abortModules, setAbortModules] = useState(false);
  const [triggerModuleGeneration, setTriggerModuleGeneration] = useState(false);
  const [restartModules, setRestartModules] = useState(false);
  const [assemblyshow, setAssemblyshow] = useState(false);
  const [isMultiline, setIsMultiline] = useState(false);
  const moduleCreation = {
    showModuleCreation,
    setShowModuleCreation,
  };
  const multiModules = { multiModuleCreation, setMultiModuleCreation };
  const startNew = { showNewBubble, setShowNewBubble };
  const goNextPrompt = { goforward, setGoForward };
  const slidePopup = { showSlideMsg, setShowSlideMsg };
  const generatemultimodBtn = { generateMultiMod, setGenerateMultiMod };
  const moduleGenerate = { goforGenerate, setGoforGenerate };
  const cancelbtn = { cancelGenerate, setCancelGenerate };
  const cancelAbort = { abortModules, setAbortModules };
  const triggerMulti = { triggerModuleGeneration, setTriggerModuleGeneration };
  const restartMod = { restartModules, setRestartModules };
  const startAssembly = { assemblyshow, setAssemblyshow };
  const inputControll = { inputHidden, setInputHidden };
  const resetPop = { recModules, setRecModules };
  const multiIP = { isMultiline, setIsMultiline };
  // Cancel generation - called when CANCEL button is clicked

  const handleCancelGeneration = () => {
    setCancelGenerate(true);
    setAbortModules(true);
    setTextShow(false);
  };

  useEffect(() => {
    // handleCancelGeneration()

    setGenerateMultiMod(false);
    setMultiModuleCreation(false);
    setRestartModules(false);
    setAssemblyshow(false);
    setTriggerModuleGeneration(false);
    setAbortModules(false);
  }, [selectedeDetail, selectedSlide]);

  useEffect(() => {
    setShowNewBubble(false);
  }, [generateMultiMod, restartModules]);
  const handleUserMessage = (userInput) => {
    // Simulate bot response with empty data instead of making API call
    const botResponse = {
      id: Date.now() + 1,
      sender: "bot",
      timestamp: new Date().toISOString(),
      data: [], // send empty array instead of real API data
      responseType: "edetail",
    };
    setInputHidden(true);
    setMessages((prev) => [...prev, botResponse]);
  };

  const handleSendMessage = async (userInput) => {
    if (!userInput.trim()) return;
    setTextShow(false);
    if (dropDownlist?.topiclist.length > 0 && userInput.length > 0) {
      setDropDownlist({ topiclist: [], confirmationPop: false });
      setTextShow(false);
    }

    const baseId = Date.now();
    const userMessage = {
      id: baseId,
      text: userInput,
      sender: "user",
      timestamp: new Date().toISOString(),
      rawData: userInput,
      responsetype: "text",
    };

    const loadingMessage = {
      id: baseId + 1,
      sender: "bot",
      timestamp: new Date().toISOString(),
      isLoading: true,
      responseType: "text",
    };

    setMessages((prev) => [...prev, userMessage, loadingMessage]);
    setShowChat(true);

    try {
      const responses = await fetchProductCountry(userInput);

      // Check for final "Thanks — confirmed" message
      const isFinalConfirmationMessage = responses.some(
        (response) =>
          response.text ===
            "Thanks — confirmed. Metadata collection is complete." ||
          (response.text && response.text.includes("Thanks — confirmed")) ||
          (response.text &&
            response.text.includes("Metadata collection is complete")),
      );

      // If it's the final confirmation message, handle it and exit
      if (isFinalConfirmationMessage && responses.length === 1) {
        const response = responses[0];
        const product = response.meta?.product;
        const country = response.meta?.country;
        const topic = response.meta?.topic;
        const communicationObjectives = response.meta?.communicationObjectives;

        if (product && country && topic && communicationObjectives) {
          // Store metadata
          const finalMeta = {
            product: product,
            country: country,
            objective: communicationObjectives,
            topic: topic,
            timestamp: new Date().toISOString(),
            userInput: userInput,
            responseId: baseId + 2,
            isMetadataExtractionDone: true,
          };

          setUserCollectedMeta((prev) => {
            const exists = prev.some(
              (item) =>
                item.product === finalMeta.product &&
                item.country === finalMeta.country &&
                item.topic === finalMeta.topic &&
                JSON.stringify(item.objective) ===
                  JSON.stringify(finalMeta.objective) &&
                item.isMetadataExtractionDone === true,
            );

            if (!exists) return [...prev, finalMeta];
            return prev;
          });

          // Remove loading message, DON'T add the final message, and disconnect
          setMessages((prev) =>
            prev.filter((msg) => msg.id !== loadingMessage.id),
          );
          setProductCountry({
            product: product,
            country: country,
            userInput: userInput,
          });
          setShowNewBubble(false);
          disconnect();
          handleUserMessage({
            product: product,
            country: country,
            topic: topic,
            communicationObjectives: communicationObjectives,
            userInput: userInput,
            isMetadataExtractionDone: true,
          });
          setTextShow(false);
          return; // Exit the function completely
        }
      }

      if (responses && responses.length > 0) {
        // Check if user wants to proceed with metadata confirmation
        const normalizedInput = userInput.toLowerCase().trim();
        const userWantsToProceed =
          normalizedInput === "yes proceed" ||
          normalizedInput.includes("yes, proceed") ||
          normalizedInput.includes("proceed") ||
          normalizedInput.includes("that's all") ||
          normalizedInput.includes("that's all. please go for next step") ||
          normalizedInput.includes("please go") ||
          normalizedInput.includes("please go.");

        // FIRST: Check if this is a follow-up "yes proceed" message
        if (userWantsToProceed) {
          // Look for any previous bot message that had complete metadata
          const previousMessages = [...messages];
          const lastBotMessageWithCompleteMeta = previousMessages
            .reverse()
            .find(
              (msg) =>
                msg.sender === "bot" &&
                msg.meta?.product &&
                msg.meta?.country &&
                msg.meta?.topic &&
                msg.meta?.communicationObjectives &&
                msg.isMetadataExtractionDone === true,
            );

          if (lastBotMessageWithCompleteMeta) {
            // We found a previous message with complete metadata
            const product = lastBotMessageWithCompleteMeta.meta.product;
            const country = lastBotMessageWithCompleteMeta.meta.country;
            const topic = lastBotMessageWithCompleteMeta.meta.topic;
            const communicationObjectives =
              lastBotMessageWithCompleteMeta.meta.communicationObjectives;

            if (product && country && topic && communicationObjectives) {
              // Store metadata
              const finalMeta = {
                product: product,
                country: country,
                objective: communicationObjectives,
                topic: topic,
                timestamp: new Date().toISOString(),
                userInput: userInput,
                responseId: baseId + 2,
                isMetadataExtractionDone: true,
              };

              setUserCollectedMeta((prev) => {
                const exists = prev.some(
                  (item) =>
                    item.product === finalMeta.product &&
                    item.country === finalMeta.country &&
                    item.topic === finalMeta.topic &&
                    JSON.stringify(item.objective) ===
                      JSON.stringify(finalMeta.objective) &&
                    item.isMetadataExtractionDone === true,
                );

                if (!exists) return [...prev, finalMeta];
                return prev;
              });

              // Remove loading message and disconnect
              setMessages((prev) =>
                prev.filter((msg) => msg.id !== loadingMessage.id),
              );
              setProductCountry({
                product: product,
                country: country,
                userInput: userInput,
              });
              disconnect();
              handleUserMessage({
                product: product,
                country: country,
                topic: topic,
                communicationObjectives: communicationObjectives,
                userInput: userInput,
                isMetadataExtractionDone: true,
              });
              setTextShow(false);
              return;
            }
          }
        }

        // Check if current response has isMetadataExtractionDone === true
        const metadataExtractionResponse = responses.find(
          (response) => response.isMetadataExtractionDone === true,
        );

        // If we have metadata extraction complete response
        if (metadataExtractionResponse) {
          const product = metadataExtractionResponse.meta?.product;
          const country = metadataExtractionResponse.meta?.country;
          const topic = metadataExtractionResponse.meta?.topic;
          const communicationObjectives =
            metadataExtractionResponse.meta?.communicationObjectives;

          if (product && country && topic && communicationObjectives) {
            // Store metadata
            const finalMeta = {
              product: product,
              country: country,
              objective: communicationObjectives,
              topic: topic,
              timestamp: new Date().toISOString(),
              userInput: userInput,
              responseId: baseId + 2,
              isMetadataExtractionDone: true,
            };

            setUserCollectedMeta((prev) => {
              const exists = prev.some(
                (item) =>
                  item.product === finalMeta.product &&
                  item.country === finalMeta.country &&
                  item.topic === finalMeta.topic &&
                  JSON.stringify(item.objective) ===
                    JSON.stringify(finalMeta.objective) &&
                  item.isMetadataExtractionDone === true,
              );

              if (!exists) return [...prev, finalMeta];
              return prev;
            });

            // Immediately disconnect and hide message for all metadata completion
            setMessages((prev) =>
              prev.filter((msg) => msg.id !== loadingMessage.id),
            );
            setProductCountry({
              product: product,
              country: country,
              userInput: userInput,
            });
            disconnect();
            handleUserMessage({
              product: product,
              country: country,
              topic: topic,
              communicationObjectives: communicationObjectives,
              userInput: userInput,
              isMetadataExtractionDone: true,
            });
            setTextShow(false);
            return;
          }
        }

        // Continue with normal flow - show all responses
        setMessages((prev) => {
          const withoutLoading = prev.filter(
            (msg) => msg.id !== loadingMessage.id,
          );

          // Add all bot responses
          responses.forEach((response, index) => {
            const botResponseMessage = {
              id: baseId + 2 + index,
              text:
                response.text ||
                response.message ||
                response.response ||
                `Response ${index + 1}`,
              sender: "bot",
              timestamp: new Date().toISOString(),
              rawData: response,
              meta: response.meta,
              expected_field: response.meta?.expected_field,
              dropdown: response.meta?.dropdown,
              responseIndex: index + 1,
              isMetadataExtractionDone:
                response.isMetadataExtractionDone || false,
            };
            withoutLoading.push(botResponseMessage);
          });

          return withoutLoading;
        });

        // Store metadata if available
        responses.forEach((response) => {
          const product = response.meta?.product;
          const country = response.meta?.country;
          const topic = response.meta?.topic;
          const communicationObjectives =
            response.meta?.communicationObjectives;

          // Check reject action based on response data
          if (response.action === "reject") {
            // Check if response has valid dropdown
            const hasValidDropdownInResponse = () => {
              if (!response.meta?.dropdown) return false;
              const dropdown = response.meta.dropdown;
              const keys = Object.keys(dropdown);
              if (keys.length === 0) return false;

              for (const key of keys) {
                if (Array.isArray(dropdown[key]) && dropdown[key].length > 0) {
                  return true;
                }
              }
              return false;
            };

            const hasDropdownInResponse = hasValidDropdownInResponse();

            // If response has reject action AND empty dropdown in response, show bubble
            if (!hasDropdownInResponse) {
              // Set productCountry if response has product and country
              // if (response.meta?.product && response.meta?.country) {
              //   setProductCountry({
              //     product: response.meta.product,
              //     country: response.meta.country,
              //     userInput: userInput,
              //   });
              // }
              setDropDownlist({ topiclist: [], confirmationPop: true });
              setTextShow(true);
              // setShowNewBubble(true);
              setProductCountry(null);
              setGoForward(false);

              return; // Exit early
            } else {
              // If has dropdown, hide bubble
              setTextShow(false);
              setShowNewBubble(false);
            }
          }

          // Store if ALL fields exist AND isMetadataExtractionDone is true
          if (
            product &&
            country &&
            topic &&
            communicationObjectives &&
            response.isMetadataExtractionDone === true
          ) {
            const metaData = {
              product: product,
              country: country,
              topic: topic,
              objective: communicationObjectives,
              timestamp: new Date().toISOString(),
              userInput: userInput,
              responseId: baseId + 2,
              isMetadataExtractionDone: true,
            };

            setUserCollectedMeta((prev) => {
              const exists = prev.some(
                (item) =>
                  item.product === metaData.product &&
                  item.country === metaData.country &&
                  item.topic === metaData.topic &&
                  JSON.stringify(item.objective) ===
                    JSON.stringify(metaData.objective) &&
                  item.isMetadataExtractionDone === true,
              );

              if (!exists) return [...prev, metaData];
              return prev;
            });

            // Immediately disconnect and hide message for this case too
            setMessages((prev) =>
              prev.filter((msg) => msg.id !== loadingMessage.id),
            );
            setProductCountry({
              product: product,
              country: country,
              userInput: userInput,
            });
            setShowNewBubble(false);
            disconnect();
            handleUserMessage({
              product: product,
              country: country,
              topic: topic,
              communicationObjectives: communicationObjectives,
              userInput: userInput,
              isMetadataExtractionDone: true,
            });
            setTextShow(false);
            return;
          } else {
            // Handle dropdowns for regular responses
            const needsProceedBtn = responses.some(
              (response) =>
                (response.text &&
                  response.text.toLowerCase().includes("confirm")) ||
                response.text.toLowerCase().includes("proceed") ||
                response.text.toLowerCase().includes("correct"),
            );

            if (product && country && topic && communicationObjectives) {
              setGoForward(true);
              setTextShow(true);
            }

            // Check for valid dropdown
            const hasValidDropdown = () => {
              if (!response.meta?.dropdown) return false;
              const dropdown = response.meta.dropdown;
              const keys = Object.keys(dropdown);
              if (keys.length === 0) return false;

              for (const key of keys) {
                if (Array.isArray(dropdown[key]) && dropdown[key].length > 0) {
                  return true;
                }
              }
              return false;
            };

            const hasDropdown = hasValidDropdown();

            if (hasDropdown) {
              setProductCountry(null);
              setShowNewBubble(false);
              setTextShow(false);
              const dropdownKeys = Object.keys(response.meta.dropdown);
              const dropdownType = dropdownKeys[0] || "topic";
              let dropdownList = [];

              for (const key of dropdownKeys) {
                if (
                  Array.isArray(response.meta.dropdown[key]) &&
                  response.meta.dropdown[key].length > 0
                ) {
                  dropdownList = response.meta.dropdown[key];
                  break;
                }
              }

              setDropDownlist({
                topiclist: dropdownList,
                nameOfdropdown: dropdownType,
                confirmationPop: false,
              });
              setTextShow(true);
            } else {
              // Show confirmation popup only if we have product and country
              if (product && country) {
                setTimeout(() => {
                  setDropDownlist({
                    topiclist: [],
                    confirmationPop: true,
                  });
                  setTextShow(true);
                }, 0);
              }
            }
          }
        });
      } else {
        // Handle case with no responses
        setMessages((prev) => {
          const withoutLoading = prev.filter(
            (msg) => msg.id !== loadingMessage.id,
          );
          const emptyResponseMessage = {
            id: baseId + 2,
            text: "I didn't receive any responses. Please try again.",
            sender: "bot",
            timestamp: new Date().toISOString(),
          };
          withoutLoading.push(emptyResponseMessage);
          return withoutLoading;
        });
        setTextShow(true);
      }
    } catch (error) {
      console.error(
        "Error processing request for userInput:",
        userInput,
        error,
      );

      // Check if it's a WebSocket disconnected error
      if (
        error.message.includes("WebSocket is not connected") ||
        error.message.includes("WebSocket not initialized")
      ) {
        // Show error message for WS disconnect
        setMessages((prev) => {
          const withoutLoading = prev.filter(
            (msg) => msg.id !== loadingMessage.id,
          );

          const errorMessage = {
            id: baseId + 2,
            text: "Sorry, something went wrong. Please try again.",
            sender: "bot",
            timestamp: new Date().toISOString(),
          };

          withoutLoading.push(errorMessage);
          setShowNewBubble(true);
          setTextShow(true);
          return withoutLoading;
        });
      } else {
        // For other errors, just remove loading message without showing error
        setMessages((prev) =>
          prev.filter((msg) => msg.id !== loadingMessage.id),
        );
      }
    }
  };

  const checkeDetailSelect = (selectedCardId) => {
    setSelectedEdetail(selectedCardId);

    setSelectedSlide(null);
    // Only set to true if selectedCardId is a non-empty string
    if (
      typeof selectedCardId === "string" &&
      selectedCardId.trim().length > 0
    ) {
      SetedetailTextShow(true);
    } else {
      SetedetailTextShow(false); // or handle the false case as needed
    }
  };

  useEffect(() => {
    setTextShow(false);
    setShowNewBubble(false);
    setSelectedSlide(null);
    SetSlideTextShow(false);
    if (edetailtextShow) {
      setShowNewBubble(false);
    }
  }, [selectedeDetail]);

  useEffect(() => {
    const hasSlides = selectedSlide?.slideIds?.length > 0;
    if (hasSlides) {
      setTextShow(false);
      setShowNewBubble(false);
    }
    if (!hasSlides && selectedeDetail) {
      setTextShow(true);
      setShowNewBubble(true);
    }
  }, [selectedSlide]);

  const checkSlideSelect = (selectedCard) => {
    setSelectedSlide(selectedCard);
    const hasSlides = selectedCard?.slideIds?.length > 0;
    SetSlideTextShow(hasSlides);
  };

  const handleProceedeDetail = (id) => {
    // Add the "Proceed with select" user message
    const userMessage = {
      id: Date.now(),
      text: "Proceed with selection",
      sender: "user",
      timestamp: new Date().toISOString(),
      rawData: "Proceed with select",
      proceedtype: "Edetail",
    };
    setMessages((prev) => [...prev, userMessage]);

    fetchPreview(id, (response, error) => {
      if (error) {
        console.error("Failed to fetch preview:", error);
        toast.error("Something went wrong while fetching the preview", {
          position: "top-right",
          autoClose: 5000,
        });
        return;
      }

      if (response?.pageDetails?.length > 0) {
        setSlidesData(response);

        // Add the bot response with slide data
        const botResponse = {
          id: Date.now() + 1,
          sender: "bot",
          timestamp: new Date().toISOString(),
          data: response,
          responseType: "slide",
          edtName: edtName,
        };
        setMessages((prev) => [...prev, botResponse]);
      } else {
        console.warn("No page details found in the response.");
      }
    });
  };
  const countryName = productCountry?.country || null;

  const handleModuledata = useCallback(
    async (ele, currentComboSlides = null) => {
      const slidesToUse = currentComboSlides?.allSlides || selectedSlide;

      const botResponseId = Date.now() + 1;
      const initialBotResponse = {
        id: botResponseId,
        sender: "bot",
        timestamp: new Date().toISOString(),
        responseType: "fullslide",
        isLoading: true,
        data: [],
        edtName: edtName,
        slideCount: ele.slideIds.length,
        userCollectedMeta: userCollectedMeta,
      };
      setMessages((prev) => [...prev, initialBotResponse]);

      const updatedModulesData = [];
      const newCacheEntries = {};
      let hasApiErrors = false;
      let hasValidData = false;

      // Function to remove mustUse fields
      const cleanModuleData = (data) => {
        if (!data) return data;
        const cleaned = { ...data };
        if (cleaned.claims) {
          cleaned.claims = cleaned.claims.map(({ mustUse, ...rest }) => rest);
        }
        if (cleaned.reusableTexts) {
          cleaned.reusableTexts = cleaned.reusableTexts.map(
            ({ mustUse, ...rest }) => rest,
          );
        }
        if (cleaned.components) {
          cleaned.components = cleaned.components.map(
            ({ mustUse, ...rest }) => rest,
          );
        }
        return cleaned;
      };

      const lastUserMeta = userCollectedMeta[userCollectedMeta.length - 1];
      const objective = lastUserMeta?.objective || "";
      const topic = lastUserMeta?.topic || "";

      // Process cached data
      ele.slideIds.forEach((slideId) => {
        const cacheKey = `${ele.assetId}_${slideId}`;
        const cachedData = modulesCache[cacheKey];

        // Check if cache has claims OR reusableTexts
        const hasClaims = cachedData?.claims && cachedData.claims.length > 0;
        const hasReusableTexts =
          cachedData?.reusableTexts && cachedData.reusableTexts.length > 0;
        const isValidCache = hasClaims || hasReusableTexts;

        if (isValidCache) {
          updatedModulesData.push({
            slideId,
            moduleData: cleanModuleData(cachedData),
          });
          hasValidData = true;
        }
      });

      // SECOND: Only fetch slides that are NOT in cache or have invalid cache
      const slideIdsToFetch = ele.slideIds.filter((slideId) => {
        const cacheKey = `${ele.assetId}_${slideId}`;
        const cached = modulesCache[cacheKey];
        // Check if cache has claims OR reusableTexts
        const hasValidCache =
          cached &&
          ((cached.claims && cached.claims.length > 0) ||
            (cached.reusableTexts && cached.reusableTexts.length > 0));
        return !hasValidCache;
      });

      if (slideIdsToFetch.length > 0) {
        const promises = slideIdsToFetch.map((slideId) =>
          getAllModules(ele.assetId, slideId, countryName, objective, topic)
            .then((response) => {
              // Check if response has claims OR reusableTexts
              const hasClaims = response?.claims && response.claims.length > 0;
              const hasReusableTexts =
                response?.reusableTexts && response.reusableTexts.length > 0;
              const isValidResponse =
                response && (hasClaims || hasReusableTexts);

              if (isValidResponse) {
                const cleanedResponse = cleanModuleData(response);
                const cacheKey = `${ele.assetId}_${slideId}`;
                newCacheEntries[cacheKey] = cleanedResponse;
                updatedModulesData.push({
                  slideId,
                  moduleData: cleanedResponse,
                });
                hasValidData = true;
              } else {
                console.warn(
                  `SKIPPED - No claims or reusableTexts: ${slideId}`,
                );
              }
            })
            .catch((error) => {
              console.error(` API FAILED for ${slideId}:`, error);
              hasApiErrors = true;
            }),
        );
        await Promise.allSettled(promises);
      }

      // Update cache with new entries
      if (Object.keys(newCacheEntries).length > 0) {
        setModulesCache((prev) => ({ ...prev, ...newCacheEntries }));
      }

      if (hasApiErrors) {
        toast.error(
          "Failed to fetch data for some slides. Using cached data where available.",
          {
            position: "top-right",
            autoClose: 5000,
          },
        );
      }

      if (!hasValidData) {
        const userMessage = {
          id: Date.now() + 1,
          sender: "bot",
          timestamp: new Date().toISOString(),
          data: [],
          text: "Claims and reusable texts in these selected slides are not approved for use",
        };
        setMessages((prev) => [...prev, userMessage]);

        toast.warning(
          "Claims and reusable texts in these selected slides are not approved for use",
          {
            position: "top-right",
            autoClose: 5000,
          },
        );
        setShowNewBubble(true);

        setTextShow(true);
        setMessages((prev) => prev.filter((msg) => msg.id !== botResponseId));
        // throw new Error("No valid data found in selected slides");
      }

      // Filter and update messages
      const filteredSelectedSlide = getFilteredSelectedSlide(
        slidesToUse,
        updatedModulesData,
      );

      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === botResponseId
            ? {
                ...msg,
                data: updatedModulesData,
                selectedSlide: filteredSelectedSlide,
                isLoading: false,
              }
            : msg,
        ),
      );

      setModulesData(updatedModulesData);
      setTextShow(true);
      setShowNewBubble(true);
      return true;
    },
    [
      modulesCache,
      selectedSlide,
      comboSlides,
      userCollectedMeta,
      countryName,
      edtName,
      getFilteredSelectedSlide,
    ],
  );
  const generateManyModules = () => {
    setTextShow(false);
    setGenerateMultiMod(false);
    setTriggerModuleGeneration(true);
  };
  const letsdisconnect = () => {
    setSelectedEdetail(null);
    setSelectedEdetail(null);
    disconnect();
    setTextShow(false);
    setShowNewBubble(false);
  };
  return (
    <>
      {wsloading && (
        <>
          <CircularProgressBar isloading={wsloading} />
        </>
      )}

      <Header isGenai={true} disconnect={letsdisconnect} />
      <div style={{ display: showChat ? "block" : "none" }}>
        <ChatContainer
          messages={messages}
          checkeDetailSelect={checkeDetailSelect}
          checkSlideSelect={checkSlideSelect}
          productCountry={productCountry}
          setProductCountry={setProductCountry}
          selectedeDetail={selectedeDetail}
          SetedetailTextShow={SetedetailTextShow}
          slidesData={slidesData}
          modulesData={modulesData}
          selectedSlide={selectedSlide}
          setedtName={setedtName}
          countryName={countryName}
          setSelectedSlide={setSelectedSlide}
          setSelectedEdetail={setSelectedEdetail}
          edetailtextShow={edetailtextShow}
          textShow={textShow}
          slidetextShow={slidetextShow}
          setSlideBubbleState={setSlideBubbleState}
          moduleCreation={moduleCreation}
          multiModules={multiModules}
          slidePopup={slidePopup}
          generatemultimodBtn={generatemultimodBtn}
          setTextShow={setTextShow}
          moduleGenerate={moduleGenerate}
          cancelbtn={cancelbtn}
          cancelAbort={cancelAbort}
          triggerMulti={triggerMulti}
          restartMod={restartMod}
          startAssembly={startAssembly}
          startNew={startNew}
          multiIP={multiIP}
          lineCount={lineCount}
        />
      </div>

      <div style={{ display: !showChat ? "block" : "none" }}>
        <DefaultContainer
          onSend={handleSendMessage}
          setUserText={setUserText}
        />
      </div>

      <ModuleInput
        selectedeDetail={selectedeDetail}
        selectedSlide={selectedSlide}
        onSend={handleSendMessage}
        productCountry={productCountry}
        setProductCountry={setProductCountry}
        handleUserMessage={handleUserMessage}
        textShow={textShow}
        setTextShow={setTextShow}
        handleProceedeDetail={handleProceedeDetail}
        edetailtextShow={edetailtextShow}
        SetedetailTextShow={SetedetailTextShow}
        handleModuledata={handleModuledata}
        setSelectedEdetail={setSelectedEdetail}
        setSelectedSlide={setSelectedSlide}
        slidetextShow={slidetextShow}
        SetSlideTextShow={SetSlideTextShow}
        setMessages={setMessages}
        setShowChat={setShowChat}
        showChat={showChat}
        setUserText={setUserText}
        slideBubbleState={slideBubbleState}
        disconnect={disconnect}
        reconnect={reconnect}
        dropDownlist={dropDownlist}
        setDropDownlist={setDropDownlist}
        moduleCreation={moduleCreation}
        comboSlides={comboSlides}
        setComboSlides={setComboSlides}
        setMultiModuleCreation={setMultiModuleCreation}
        startNew={startNew}
        goNextPrompt={goNextPrompt}
        slidePopup={slidePopup}
        generatemultimodBtn={generatemultimodBtn}
        generateManyModules={generateManyModules}
        cancelbtn={cancelbtn}
        handleCancelGeneration={handleCancelGeneration}
        restartMod={restartMod}
        assemblyshow={assemblyshow}
        setAssemblyshow={setAssemblyshow}
        inputControll={inputControll}
        resetPop={resetPop}
        multiIP={multiIP}
        lineCount={lineCount}
        setLineCount={setLineCount}
      />
    </>
  );
};
